import { Calendar, momentLocalizer } from "react-big-calendar";
import { Card } from "antd";
import { useMemo, useState } from "react";
import moment from "moment";
import "./Medicaid.scss";
import classNames from "classnames";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import CustomToolBar from "./CustomToolBar";

const localizer = momentLocalizer(moment);

const Medicaid = () => {
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState("month");

  const windowSize$ = useSharedState();

  const events = [
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-01-08T02:00:00"),
      end: new Date("2026-01-08T02:30:00"),
      bgColor: '',
      color: 'red'
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-01-08T02:00:00"),
      end: new Date("2026-01-08T02:30:00"),
      color: 'red',
      bgColor: ''
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-01-08T02:00:00"),
      end: new Date("2026-01-08T02:30:00"),
      bgColor: '',
      color: 'red'
    },
    {
      id: 1746,
      title: "Arcutis Meeting: Dr. Ashish Bhatia @ AAD",
      start: new Date("2026-01-08T02:00:00"),
      end: new Date("2026-01-08T02:30:00"),
      bgColor: '',
      color: 'red'
    },
    
    {
      id: 1747,
      title: "Arcutis Meeting Dr. Christopher Obeime, MD AAD 2026 12:00 PM",
      start: new Date("2026-03-09T21:30:00"),
      end: new Date("2026-03-09T22:30:00"),
      bgColor: '',
      color: 'black'
    },
    {
      id: 1748,
      title: "AAD 2026 Mark Lebwohl + Arcutis @ 3:30pm EST [In-person]",
      start: new Date("2026-03-10T01:00:00"),
      end: new Date("2026-03-10T01:30:00"),
      bgColor: '',
      color: 'red'
    },
    {
      id: 1749,
      title: "Arcutis Meeting Dr. Scott Drew AAD 2026 3:00 pm",
      start: new Date("2026-03-09T01:30:00"),
      end: new Date("2026-03-09T01:55:00"),
      bgColor: '',
      color: 'black'
    },
  ];

  const components = useMemo(
    () => ({
      toolbar: CustomToolBar,
    }),
    []
  );

  const columns = [
    {
      label: "Medicaid",
      link: "",
    },
  ];

  const eventPropsHandler = (event, start, end, isSelected) => {
    console.log(start, end, isSelected, "event prop getter")
    return {
      style: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: event.color,
        border: "none",
        padding: "2px 6px",
        boxShadow: "none"
      },
    };
  };

  return (
    <div className="details-root" data-test="details-container">
      <div className="container">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>

        <Card>
          <div
            className={classNames("calendar-height calender-big", {
              "margin-classs":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "margin-class":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            <Calendar
              localizer={localizer}
              events={events}
              startAccessor="start"
              endAccessor="end"
              date={date}
              view={view}
              onNavigate={setDate}
              onView={setView}
              components={components}
              eventPropGetter={eventPropsHandler}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Medicaid;


